import {
  add
} from "../../commonFunctions";
import { controls } from "../../controls";

const rp002 = {
  label: "Day Book",
  starting: true,
  url: "rp002",
  pageLabel: "Sub Day Book",
  pageType: "history",

  filter: [
    ...controls.displayText({ tab: "filter", label: "Parent Branch", width: "col-sm-2" }),
    ...controls.branch({ tab: "filter", width: "col-sm-2" }),
    ...controls.showData({ tab: "filter", data: "branch_display", name: "branch_display", width: "col-sm-2" }),
    ...controls.displayText({ tab: "filter", label: "General Ledger", width: "col-sm-2" }),
    ...controls.GL({ tab: "filter" }),
    ...controls.showData({ tab: "filter", data: "gl_code_display", name: "gl_code_display", width: "col-sm-2" }),

    ...controls.displayText({ tab: "filter", label: "GL Sub Head", width: "col-sm-2" }),
    ...controls.product({ tab: "filter", width: "col-sm-2" }),
    ...controls.showData({ tab: "filter", width: "col-sm-2", data: "product_code_display", name: "product_code_display" }),


    ...controls.magicDateLabel({ tab: "filter", star: true, label: "As on Date", width: "col-sm-2" }),
    ...controls.magicDate({ tab: "filter", name: "as_on_date", width: "col-sm-2", dateType: "ontype", isRequired: true, default: "sessiondate" }),
    ...controls.displayText({ tab: "filter", width: "col-sm-2" }),


  ],
  form: [],
  history: {
    perPage: 10,
    reportHeader: "Sub Day Book",
    pdfProps: { pageSize: "A4", pageOrientation: "landscape" },
    subtotals: {
      grandtotal: { fields: ["credit_cash", "credit_transfer", "credit_total", "debit_cash", "debit_transfer", "debit_total"], count: true },
      subtotal: [{ by: "account_number", displayIn: "account_number", text: "Sub Total", count: true, groupedRows: false }]
    },
    displayColumns: [
      {
        Header: "Sr",
        type: "autoinc",
        accessor: "srno",
        width: 30,
      },
      {
        Header: "Ac No",
        accessor: "account_number",
      },
      {
        Header: "Description",
        accessor: "description",
        width: 250,
        rwidth: "*"
      },
      {
        Header: "Particulars",
        accessor: "particulars",
        width: 140,
      },
      {
        Header: "Credit",
        columns: [
          {
            Header: "Cash",
            accessor: "credit_cash",
            type: "currency"
          },
          {
            Header: "Transfer",
            accessor: "credit_transfer",
            type: "currency"
          },
          {
            Header: "Total",
            accessor: "credit_total",
            type: "currency",
            formula: [{ f: 'simpleArithmatic', calcType: 'sum', inputs: [{ source: 'row', field: 'credit_cash' }, { source: 'row', field: 'credit_transfer' }], resultVar: 'total' }],
          }
        ]
      },
      {
        Header: "Debit",
        columns: [
          {
            Header: "Cash",
            accessor: "debit_cash",
            type: "currency"
          },
          {
            Header: "Transfer",
            accessor: "debit_transfer",
            type: "currency"
          },
          {
            Header: "Total",
            accessor: "debit_total",
            type: "currency",
            formula: [{ f: 'simpleArithmatic', calcType: 'sum', inputs: [{ source: 'row', field: 'debit_cash' }, { source: 'row', field: 'debit_transfer' }], resultVar: 'total' }],
          }
        ]
      },
    ]
  }
};

export default rp002;
